var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconEye = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.065,
    height: 17.375,
    viewBox: "0 0 23.065 17.375",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(-1549.467 -325.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M1.5,13.587S5.294,6,11.933,6s10.433,7.587,10.433,7.587-3.794,7.587-10.433,7.587S1.5,13.587,1.5,13.587Z",
    transform: "translate(1549.067 320.413)",
    fill: "none",
    stroke: "#25326a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M19.19,16.345A2.845,2.845,0,1,1,16.345,13.5,2.845,2.845,0,0,1,19.19,16.345Z",
    transform: "translate(1544.655 317.655)",
    fill: "none",
    stroke: "#25326a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-eye.798321a0.svg";
export { ForwardRef as ReactComponent };